
import { StatCard } from "../../common"

type WorkoutDetailsItemProps = {
  description: string
  color: string
}

export const ActionsItem: React.FC<WorkoutDetailsItemProps> = ({
  description,
  color,
}) => {
  const stimulus = color?.trim() ?? ""
  return (
    <StatCard
      title="Ação:"
      description={description}
      stats={[]}            
      onClose={() => { }}
      stimulusColor={stimulus || undefined}      
    />
  )
}